import { Divider, MenuItem, styled } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)`
  height: 38px;
  padding-top: ${({ theme }) => theme.spacing(0)};
  padding-bottom: ${({ theme }) => theme.spacing(0)};
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  > .MuiListItemIcon-root {
    justify-content: center;
  }
  > p {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const CustomDivider = styled(Divider)`
  margin-top: 0px !important;
  margin-bottom: 0px !important;
`;

export const RowHeaderTitle = styled('div')({
  position: 'sticky',
  '> div': {
    transform: 'rotate(180deg)',
    writingMode: 'vertical-lr',
  },
});
